import React, { useLayoutEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import {
  DASHBOARD_NAV_COLLAPSED_WIDTH,
  DASHBOARD_NAV_EXPANDED_WIDTH,
  useDashboardShell,
} from '../contexts/DashboardShellContext';
import { isDashboardPath } from '../util/dashboardRoutes';

const DashboardContentFrame: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { leftRailWidth, navigationOpen } = useDashboardShell();
  const dashboard = isDashboardPath(location.pathname);
  const rightInset = dashboard && desktop
    ? navigationOpen
      ? DASHBOARD_NAV_EXPANDED_WIDTH
      : DASHBOARD_NAV_COLLAPSED_WIDTH
    : 0;
  const leftInset = dashboard ? leftRailWidth : 0;
  const topInset = dashboard ? 'var(--fable-dashboard-header-height)' : '0px';

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--fable-dashboard-modal-left', `${leftInset}px`);
    root.style.setProperty('--fable-dashboard-modal-right', `${rightInset}px`);
    root.style.setProperty('--fable-dashboard-modal-top', topInset);

    return () => {
      root.style.removeProperty('--fable-dashboard-modal-left');
      root.style.removeProperty('--fable-dashboard-modal-right');
      root.style.removeProperty('--fable-dashboard-modal-top');
    };
  }, [leftInset, rightInset, topInset]);

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        pr: `${rightInset}px`,
        pt: topInset,
        transition: 'padding-right 0.22s ease',
      }}
    >
      {children}
    </Box>
  );
};

export default DashboardContentFrame;
